<section>
    <span c-activity-log-blurb activity="activity"></span>{{message}}
    <span class="modelObject" ng-repeat="modelObjectName in modelObjectsNames track by $index">
        <span ng-bind-html="modelObjectAsHtml(localize(modelObjectName))"></span>{{$last ? '' : ','}}
    </span>
</section>